/*
 * @prop --component-paragraph-color: Color of paragraph
 */

:host {
  display: block;
  color: var(--component-paragraph-color, var(--current-color-text, $ui-dark));

  ::slotted(mark) {
    @extend %mark;
  }
}
